// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.location-info {
    font-family: Arial, sans-serif;
    margin: 20px auto;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 10px;
    max-width: 500px;
    background-color: #f9f9f9;
  }
  
  .location-info h2 {
    font-size: 1.5em;
    margin-bottom: 10px;
  }
  
  .location-info p {
    font-size: 1em;
    margin: 5px 0;
  }
  
  .vpn-warning {
    color: red;
    font-weight: bold;
  }
  
  .loading,
  .error {
    font-family: Arial, sans-serif;
    margin: 20px auto;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 10px;
    max-width: 500px;
    background-color: #f9f9f9;
    text-align: center;
  }
  
  .loading {
    color: #555;
  }
  
  .error {
    color: red;
  }
  `, "",{"version":3,"sources":["webpack://./src/MyComponents/LocationInfo/locationinfo.css"],"names":[],"mappings":";AACA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;;EAEA;;IAEE,8BAA8B;IAC9B,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ","sourcesContent":["\n.location-info {\n    font-family: Arial, sans-serif;\n    margin: 20px auto;\n    padding: 20px;\n    border: 1px solid #ccc;\n    border-radius: 10px;\n    max-width: 500px;\n    background-color: #f9f9f9;\n  }\n  \n  .location-info h2 {\n    font-size: 1.5em;\n    margin-bottom: 10px;\n  }\n  \n  .location-info p {\n    font-size: 1em;\n    margin: 5px 0;\n  }\n  \n  .vpn-warning {\n    color: red;\n    font-weight: bold;\n  }\n  \n  .loading,\n  .error {\n    font-family: Arial, sans-serif;\n    margin: 20px auto;\n    padding: 20px;\n    border: 1px solid #ccc;\n    border-radius: 10px;\n    max-width: 500px;\n    background-color: #f9f9f9;\n    text-align: center;\n  }\n  \n  .loading {\n    color: #555;\n  }\n  \n  .error {\n    color: red;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
